import React, { useState, useEffect } from "react";
import {
  Card,
  makeStyles,
  Typography,
} from "@material-ui/core";
import Service from "../Service/apiREST";
import DetailView from "./DetailView";

const useRowStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      borderBottom: "unset",
    },
    heading: {
      fontSize: theme.typography.pxToRem(15),
      fontWeight: theme.typography.fontWeightRegular,
    },
  },
  headerCard: {
    top: "304px",
    left: "0px",
    width: "500px",
    height: "110px",
    background: "#FCFCFC 0% 0% no-repeat padding-box",
    border: "1px solid #D8D8D8",
    borderRadius: "3px",
    opacity: 1,
    [theme.breakpoints.down('xs')]: {
      width: "455px"
    },
  },
  header: {
    top: "324px",
    marginTop: '11px',
    marginLeft: "30px",
    width: "450px",
    height: "109px",
    texAlign: "left",
    font: "normal normal medium 40px",
    fontFamily:"Montserrat",
    letterSpacing: "0px",
    color: "#313131",
    opacity: 1,
    lineHeight:"27px",
    [theme.breakpoints.down('xs')]: {
      marginLeft: "12px",
    },
  },
}));

function Row({eventsData, eventId, filtersData, setManuData, manuData, dateFiltersData, dataLat, dataLong, setDataLat, setDataLong, setShow, show, handleClick, countrySelected}) {

  
  const [showDetail, setShowDetail] = useState(false);
  const [manuscripts, setManuscripts] = useState([]);
  const [showCard, setShowCard] = useState(true)
  const [data, setData] = useState([]);
  const classes = useRowStyles();

  const getManu = async () => {
    const response = await Service.getManuscriptByEventId(eventId);
    setManuscripts(response.data);
  
    setData(response.data)
    setDataLat(response.data.latStart)
    setDataLong(response.data.lngStart)
  }


  useEffect(() => {
      getManu();
      setShow(showDetail)
      setShowCard(showCard)
  }, []);

  
 
    return (
      <div className={classes.root}>
        
         {showCard && <Card className={classes.headerCard} elevation={0}>
            <Typography className={classes.header}>
              Click a pin on the map to learn about how the manuscripts reporting
              news about this event spread and who wrote them.
            </Typography>
          </Card> }
          <DetailView countrySelected={countrySelected} handleClick={handleClick} events={eventsData} manuData={data} dataLat={dataLat} dataLong={dataLong} />
        
        </div>
      );
  
}

export default Row;
